import React from 'react'
import PageForm from '../PageForm'
import BackgroundImage from '../../wp-adons/BackgroundImage'
import { setMargin, setPadding } from '../../utilities'

export default function EmailSignUp ({
  pageName,
  title,
  slogan,
  background_image,
  margin_selection,
  padding_selection
}) {
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  return (
    <div
      style={{ ...pageStyles }}
      className='py-24 flex flex-col items-center justify-center relative z-0 overflow-hidden'
      id={pageName}
    >
      {title && (
        <p className='text-header5 font-jost uppercase mb-4 relative z-10'>
          {title}
        </p>
      )}
      {slogan && (
        <p className='text-header1 font-satisfy relative z-10'>{slogan}</p>
      )}
      <PageForm />
      {background_image && (
        <BackgroundImage background_image={background_image} />
      )}
    </div>
  )
}
// Get inspired by your inbox?
// Nature at your feet.
